import _ from 'underscore';

const Countries = function(hits, allTimeHitsByCountry) {
  hits = _.filter(hits, function(hit) {
    return hit.visitor && hit.visitor.country;
  });

  var canonicalize = function(countryCode) {
    return countryCode ? countryCode.toLowerCase() : 'Unknown';
  };

  var countryCodes = _.uniq(_.flatten(
    [
      _.map(hits, function(hit) { return canonicalize(hit.visitor.country.code); }),
      _.map(allTimeHitsByCountry, function(countryCount) {
        return canonicalize(countryCount.country_code);
      }),
    ],
    true
  ));

  var countries = _.map(countryCodes, function(code) {
    return { countryCode: code, thirtyDayViews: 0, cities: [], uniqueVisitors: {} };
  });

  _.each(hits, function(hit) {
    var cityName = hit.visitor.city;
    var country = _.findWhere(countries, { countryCode: canonicalize(hit.visitor.country.code) });
    if (!cityName || !country) { return; }

    var city = _.findWhere(country.cities, { name: cityName });
    if (!city) {
      city = { name: cityName, thirtyDayViews: 0, uniqueVisitors: {} };
      country.cities.push(city);
    }
  });

  _.each(hits, function(hit) {
    var country = _.findWhere(countries, { countryCode: canonicalize(hit.visitor.country.code) });
    if (!country) { return; }

    country.thirtyDayViews += 1;
    country.uniqueVisitors[hit.visitor.id] = true;

    var cityName = hit.visitor.city;
    if (cityName) {
      var city = _.findWhere(country.cities, { name: cityName });
      city.thirtyDayViews += 1;
      city.uniqueVisitors[hit.visitor.id] = true;
    }
  });

  _.each(allTimeHitsByCountry, function(countryCount) {
    var country = _.findWhere(countries, { countryCode: canonicalize(countryCount.country_code) });
    country.allTimeViews = parseInt(countryCount.all_time_hit_count, 10);
    country.countryName = countryCount.country_name;
  });

  _.each(countries, function(country) {
    country.uniqueVisitors = _.size(country.uniqueVisitors);

    _.each(country.cities, function(city) {
      city.uniqueVisitors = _.size(city.uniqueVisitors);
    });
  });

  return countries;
};


const RefererPairs = function(allTimeRefererHitCounts, hits, works) {
  var refererPagePairs = [];

  function findOrCreateByWorkIdAndRefererUrl(workId, refererUrl) {

    var pair = _.findWhere(refererPagePairs, {
      workId: workId, refererUrl: refererUrl
    });
    if (!pair) {
      pair = {
        workId: workId,
        refererUrl: refererUrl,
      };
      refererPagePairs.push(pair);
    }
    return pair;
  }

  function createRefererDataPointsFrom (hits, allTimeRefererCounts) {

    // Filter out all the hits with referers we don't want to display.
    var filtered = _.filter(hits, function(hit) {
      if (!hit.referer || !hit.referer.url) return;

      return hit.source.type == 'ExternalPage' || hit.source.type == 'ExternalSocial';
    });

    // Then iterate through the remaining hits to create model objects.
    _.each(filtered, function (hit) {
      var workIdToQueryOn = hit.page.work_id || -1;
      var refererUrl = hit.referer.url;
      var pair = findOrCreateByWorkIdAndRefererUrl(workIdToQueryOn, refererUrl);
      pair.thirtyDayViews = pair.thirtyDayViews ? pair.thirtyDayViews + 1 : 1;
    });

    // Now process the all-time-views data.
    _.each(allTimeRefererCounts, function(refererData, targetPageDescription) {

      var workId = (targetPageDescription == "Profile") ? -1 : parseInt(targetPageDescription);
      _.each(refererData, function(hitsData, refererUrl) {
        var pair = findOrCreateByWorkIdAndRefererUrl(workId, refererUrl);
        pair.allTimeViews = hitsData.all_time_views;
      });
    });

    // Now set up the data about the 'to' page for each data point.
    _.each(refererPagePairs, function(pair) {
      if (pair.workId === -1) {
        pair.targetPageTitle = "Profile";
        pair.targetPageUrl = Aedu.User.current.url;
      } else {
        var work = _.find(works, function(w) {
          return parseInt(w.id, 10) == parseInt(pair.workId, 10);
        });
        pair.targetPageTitle = work && work.title;
        pair.targetPageUrl = work && work.internal_url;
      }
    });

    return refererPagePairs;
  }

  return createRefererDataPointsFrom(hits, allTimeRefererHitCounts);
};

const Docs = function(works, hits, allTimeHitsByCountry, downloads, percentiles) {
  var docs = _.map(works, function(work) {
    // Don't mutate the passed-in works.
    return _.clone(work);
  });

  // We create a fake work to act as the CV
  var cvWork = {
    // As of right now we don't track all time stats
    // for CVs.
    allTimeDownloads: undefined,
    allTimeViews: undefined,
    id: Aedu.WorkConstants.CV_WORK_ID,
    internal_url: $viewed_user.url + '/CurriculumVitae',
    title: 'Curriculum Vitae'
  };

  docs.push(cvWork);

  var downloadsByWork = _.groupBy(downloads, 'work_id');
  var hitsByWork = _.groupBy(hits, function(hit) {
    return hit.page && hit.page.work_id;
  });
  var allTimeHitsByCountryByWork = _.groupBy(allTimeHitsByCountry, 'work_id');

  _.each(docs, function(doc) {
    var downloads = downloadsByWork[doc.id] || [];
    var hits = hitsByWork[doc.id] || [];
    var allTimeHitsByCountry = allTimeHitsByCountryByWork[doc.id] || [];
    var percentile = percentiles[doc.id];

    doc.thirtyDayDownloads = downloads.length;
    doc.thirtyDayViews = hits.length;
    doc.thirtyDayUniques = _.size(_.groupBy(hits, function(hit) {  // _.uniq would be simpler, but it's O(n^2).
      return hit.visitor.id;
    }));
    doc.countries = Countries(hits, allTimeHitsByCountry);
    doc.thirtyDayPercentile = percentile;

    doc.allTimeDownloads = doc.all_time_downloads;
    delete doc.all_time_downloads;

    doc.allTimeViews= doc.all_time_views;
    delete doc.all_time_views;
  });

  return docs;
};

export {Countries, RefererPairs, Docs};
